import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
	data() {
		return {};
	},
	props: {
		select: {
			type: Function,
			required
		}
	},
	computed: {
		...mapState('newsModule', ['technicalError', 'loading', 'newsList', 'tags'])
	},
	filters: {
		newsDate(value) {
			return moment(value).format('YYYY. MMMM D. ');
		}
	}
};
